// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"367":"b536a0f1","831":"bd904a5c"}[chunkId] || chunkId) + "." + {"367":"7090cfd01fe0132e","374":"7d7210cead1919de","831":"6ec062a599a6b655"}[chunkId] + ".js";
};